import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { SearchCategory } from '../GlobalSearchTabs';
import { ResultGroups } from '../ResultGroups';
import { ExtendedDocCompareChunkFinderChunk, Widget } from '../types';
import { WidgetResults } from '../WidgetResults';
import { InitialState } from './InitialState';
import { ThinkingState } from './ThinkingState';

interface SearchContentProps {
  error: string | null;
  showEmptyState: boolean;
  search: string;
  filteredResults: (ExtendedDocCompareChunkFinderChunk | Widget)[];
  isAnyLoading: boolean;
  activeCategory: SearchCategory;
  results: {
    widgets: Widget[];
  };
  onWidgetClick: (widget: Widget) => void;
  onFundSelect?: (fund: FundGetData) => void;
  onClose: () => void;
}

export const SearchContent = ({
  error,
  showEmptyState,
  search,
  filteredResults,
  isAnyLoading,
  activeCategory,
  results,
  onWidgetClick,
  onFundSelect,
  onClose,
}: SearchContentProps) => {
  const shouldShowWidgets =
    (activeCategory === 'All' || activeCategory === 'Widgets') &&
    results.widgets.length > 0;

  if (error) {
    return (
      <h3 className="text-center" style={{ color: 'var(--bq-text-primary)' }}>
        {error}
      </h3>
    );
  }

  if (showEmptyState) {
    return (
      <div
        className="text-center mt-3"
        style={{ color: 'var(--bq-text-secondary)' }}
      >
        No results found
      </div>
    );
  }

  if (search.trim() === '') {
    return (
      <InitialState
        widgets={results.widgets}
        onWidgetClick={onWidgetClick}
        shouldShowWidgets={shouldShowWidgets}
      />
    );
  }

  if (filteredResults.length > 0 || isAnyLoading) {
    return (
      <div className="grid">
        {isAnyLoading && (
          <div className="col-12">
            <ThinkingState />
          </div>
        )}

        <div className="col-12">
          {filteredResults.length > 0 && activeCategory === 'All' && (
            <ResultGroups
              results={filteredResults as ExtendedDocCompareChunkFinderChunk[]}
              onResultClick={(result) => {
                if (
                  result.type === 'fund' &&
                  result._originalFund &&
                  onFundSelect
                ) {
                  onFundSelect(result._originalFund);
                  onClose();
                }
              }}
              onClose={onClose}
            />
          )}
        </div>

        <div className="col-12">
          {filteredResults.length > 0 &&
            activeCategory !== 'All' &&
            activeCategory !== 'Widgets' && (
              <ResultGroups
                results={
                  filteredResults as ExtendedDocCompareChunkFinderChunk[]
                }
                onResultClick={(result) => {
                  if (
                    result.type === 'fund' &&
                    result._originalFund &&
                    onFundSelect
                  ) {
                    onFundSelect(result._originalFund);
                    onClose();
                  }
                }}
                onClose={onClose}
              />
            )}
        </div>

        <div className="col-12">
          {filteredResults.length > 0 &&
            (activeCategory === 'Widgets' || activeCategory === 'All') && (
              <WidgetResults
                widgets={
                  activeCategory === 'Widgets'
                    ? (filteredResults as Widget[])
                    : results.widgets
                }
                onWidgetClick={onWidgetClick}
              />
            )}
        </div>
      </div>
    );
  }

  return (
    <InitialState
      widgets={results.widgets}
      onWidgetClick={onWidgetClick}
      shouldShowWidgets={shouldShowWidgets}
    />
  );
};
